module.exports = __webpack_public_path__ + "01_short_black.66ea45f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer5/01_short_black.png
// module id = 0HfM
// module chunks = 0